import { CRow } from "@coreui/react";
import React, { useState, useCallback } from "react";
import "font-awesome/css/font-awesome.min.css";
import Viewer from "react-simple-image-viewer";
import Collapsible from "../collapsible/Collapsible";
import "./ImageViewer.scss";
import pdfLogo from "../../../assets/pdf-icon.png";
import JSZip from "jszip";
import FileSaver from "file-saver";

const ImageViewer = ({
  images,
  handleDeleteImage,
  hideDeleteFor,
  disableImageDelete,
}) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  /**
   * Handles downloading all images
   */
  const handleDownloadAllImages = () => {
    const zip = new JSZip();

    const today = new Date();
    const month = today.getMonth() + 1;
    const day = today.getDate();
    const year = today.getFullYear();

    const zipFileName = `Images_${month}_${day}_${year}.zip`;

    let count = 0;

    images.forEach(async (image) => {
      const fileName = image.imageBlobPath.replace(
        "https://allkindprod9d92.blob.core.windows.net/images/",
        ""
      );

      const imageData = await fetch(image.imageBlobPath, {
        method: "GET",
        redirect: "follow",
      });
      const blob = await imageData.blob();
      zip.file(fileName, blob);
      count++;

      if (count >= images.length) {
        zip.generateAsync({ type: "blob" }).then((content) => {
          FileSaver.saveAs(content, zipFileName);
        });
      }
    });
  };

  const imagePaths = [];

  return (
    <>
      <button
        type="button"
        className={`ak-custom-button ak-main-button-color-all mr-2 mt-4`}
        onClick={handleDownloadAllImages}
      >
        Download All
      </button>
      <div>
        <Collapsible collapsePrompt="Show / Hide Images" startExpanded>
          <CRow className="content-center">
            {images &&
              images.length > 0 &&
              images.map((src, index) => {
                imagePaths[index] = src.imageBlobPath;

                let hideDelete = false;
                if (hideDeleteFor && hideDeleteFor.length > 0) {
                  hideDeleteFor.forEach((entry) => {
                    if (src[entry.key] === entry.value) {
                      hideDelete = true;
                    }
                  });
                }

                return (
                  <div className="img-wrap" key={index}>
                    {!disableImageDelete && handleDeleteImage && !hideDelete && (
                      <span
                        title="Delete Image"
                        onClick={() => {
                          handleDeleteImage(src.id);
                        }}
                        className="fa fa-times-circle delete-icon"
                      ></span>
                    )}
                    <img
                      className="m-1 clickable-image img"
                      src={
                        src.imageName.split(".")[1] === "pdf"
                          ? pdfLogo
                          : src.imageBlobPath
                      }
                      onClick={() => {
                        if (src.imageName.split(".")[1] === "pdf") {
                          window.open(src.imageBlobPath, "_blank");
                        } else {
                          openImageViewer(index);
                        }
                      }}
                      width={
                        src.imageName.split(".")[1] === "pdf" ? "100" : "300"
                      }
                      key={index}
                      alt={src.imageName}
                      title={src.imageName}
                    />
                  </div>
                );
              })}
          </CRow>
        </Collapsible>
        {isViewerOpen && images && images.length > 0 && (
          <Viewer
            src={imagePaths}
            currentIndex={currentImage}
            onClose={closeImageViewer}
            disableScroll={false}
            backgroundStyle={{
              backgroundColor: "rgba(0,0,0,0.9)",
            }}
            closeOnClickOutside={true}
          />
        )}
      </div>
    </>
  );
};

export default ImageViewer;
